<template>
	<div class="overlay">
		<h3>Logging in...</h3>
	</div>
</template>

<script>
import rmdyAuth, { GOOGLE_AUTH_ACTIONS } from '@rmdy/rmdy-authentication-frontend';

export default {
	name: 'AuthenticationCallback',
	created() {
		this.$store.dispatch(`${rmdyAuth.googleModuleName}/${GOOGLE_AUTH_ACTIONS.AUTHENTICATE}`, this.$route.query.code).then(() => {
			this.$router.push('/');
		});
	},
};
</script>

<style lang="scss" scoped>
.overlay {
	display: flex;
	justify-content: center;
	align-items: center;
	margin: 0;
	width: 100vw;
	height: 100vh;
	position: absolute;
	top: 0;
	left: 0;
	z-index: 10;
}

.overlay h3 {
	font-size: 36px;
	color: white;
}
</style>
